(function () {
  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function renderItem(product) {
    var variant = product.variants && product.variants[0];
    if (!variant) return null;

    var el = document.createElement('div');
    el.className = 'cart-cross-sell__item';

    var img = document.createElement('img');
    img.loading = 'lazy';
    img.alt = product.title || '';
    if (product.featured_image) {
      img.src = product.featured_image;
    } else if (product.images && product.images[0]) {
      img.src = product.images[0];
    }

    var title = document.createElement('a');
    title.href = product.url;
    title.className = 'cart-cross-sell__item-title';
    title.textContent = product.title;

    var price = document.createElement('span');
    price.className = 'cart-cross-sell__item-price';
    price.textContent = money(variant.price);

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'cart-cross-sell__item-button';
    button.textContent = 'Adicionar';
    if (!variant.available) {
      button.textContent = 'Esgotado';
      button.disabled = true;
    }

    // Add-to-cart via FormData (mesmo payload que o Dawn usa nativamente), pra
    // cart.renderContents() reconstruir o drawer com o bloco de itens correto
    // (JSON items:[] retorna outro formato de resposta e o bloco de itens some).
    button.addEventListener('click', function () {
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      var formData = new FormData();
      formData.append('id', variant.id);
      formData.append('quantity', 1);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        formData.append('sections_url', window.location.pathname);
      }

      var original = button.textContent;
      button.disabled = true;
      button.textContent = 'Adicionando...';

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          if (response.status) {
            button.disabled = false;
            button.textContent = original;
            return;
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = original;
        });
    });

    el.appendChild(img);
    el.appendChild(title);
    el.appendChild(price);
    el.appendChild(button);
    return el;
  }

  // Cache em memoria (dura enquanto a pagina nao recarrega) por produto-semente +
  // intent. Sem isso, TODA atualizacao do carrinho (add, qty +/-, remover item)
  // recria o node .cart-cross-sell do zero e refaz a chamada de recomendacoes,
  // causando um "pulo" visual (conteudo some e reaparece ~200-500ms depois) --
  // essa era a travadinha reportada. Com cache, a mesma semente reaproveita o
  // resultado e o conteudo aparece instantaneo.
  var recCache = {};
  function fetchRecommendations(baseUrl, productId, intent) {
    var key = productId + '|' + intent;
    if (recCache[key]) return recCache[key];
    var url = baseUrl + '?product_id=' + encodeURIComponent(productId) + '&limit=6&intent=' + intent;
    var promise = fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('recommendations-failed');
        return response.json();
      })
      .catch(function (err) {
        delete recCache[key];
        throw err;
      });
    recCache[key] = promise;
    return promise;
  }

  // Setas de navegacao do carrossel (mostra so quando ha overflow horizontal).
  function setupNav(root) {
    var list = root.querySelector('.cart-cross-sell__list');
    var prev = root.querySelector('.cart-cross-sell__nav--prev');
    var next = root.querySelector('.cart-cross-sell__nav--next');
    if (!list || !prev || !next) return;

    function step() {
      var item = list.querySelector('.cart-cross-sell__item');
      var w = item ? item.getBoundingClientRect().width : list.clientWidth * 0.5;
      return (w + 10) * 2;
    }

    function update() {
      var overflow = list.scrollWidth - list.clientWidth > 4;
      if (!overflow) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      prev.hidden = false;
      next.hidden = false;
      prev.disabled = list.scrollLeft <= 2;
      next.disabled = list.scrollLeft >= list.scrollWidth - list.clientWidth - 2;
    }

    if (!root.dataset.navBound) {
      root.dataset.navBound = 'true';
      prev.addEventListener('click', function () {
        list.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        list.scrollBy({ left: step(), behavior: 'smooth' });
      });
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }

    root._updateNav = update;
    update();
  }

  function populate(root, products) {
    var list = root.querySelector('.cart-cross-sell__list');
    if (!list) return;
    list.innerHTML = '';
    products.forEach(function (product) {
      var item = renderItem(product);
      if (item) list.appendChild(item);
    });
    if (list.children.length > 0) {
      root.hidden = false;
      setupNav(root);
      window.setTimeout(function () {
        if (root._updateNav) root._updateNav();
      }, 300);
    }
  }

  function init(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var productId = root.dataset.productId;
    var baseUrl = root.dataset.recommendationsUrl;
    if (!productId || !baseUrl) return;

    fetchRecommendations(baseUrl, productId, 'complementary')
      .then(function (data) {
        var products = (data && data.products) || [];
        if (products.length > 0) {
          populate(root, products);
          return null;
        }
        return fetchRecommendations(baseUrl, productId, 'related');
      })
      .then(function (data) {
        if (!data) return;
        var products = (data && data.products) || [];
        if (products.length > 0) populate(root, products);
      })
      .catch(function () {});
  }

  function initAll() {
    document.querySelectorAll('.cart-cross-sell').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  function observeDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !('MutationObserver' in window)) return;
    var observer = new MutationObserver(function () {
      document.querySelectorAll('.cart-cross-sell:not([data-initialized])').forEach(init);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();
